/** Resolve Quill offsets without inserting spans or changing the document Delta. */
export const getQuillTextRange = (
  quill: any,
  index: number,
  length: number
): Range | null => {
  if (length <= 0) return null;
  const [startLeaf, startOffset] = quill.getLeaf(index);
  // Resolve the last character, avoiding the next leaf/embed at a boundary.
  const [endLeaf, endOffset] = quill.getLeaf(index + length - 1);
  const start = startLeaf?.domNode;
  const end = endLeaf?.domNode;
  if (start?.nodeType !== 3 || end?.nodeType !== 3) return null;
  if (!quill.root.contains(start) || !quill.root.contains(end)) return null;
  const range = quill.root.ownerDocument.createRange();
  range.setStart(start, Math.min(startOffset, start.length));
  range.setEnd(end, Math.min(endOffset + 1, end.length));
  return range;
};
